// 校验名称
// let reg = /^[\u4E00-\u9FA5]{1,10}$/;  2019/12/3 qyl修改正则  只能中文 ---->可输入中文和英文
// let reg = /^[A-z0-9\\u4e00-\\u9fa5]*$/; //可输入数字中文英文
// let reg = /^[a-zA-Z\u4e00-\u9fa5]+$/; //可输入中文或英文
export const checkName10 = (rule, value, callback) => {
  let reg = /^[a-zA-Z\u4e00-\u9fa5]+$/;
  if (reg.test(value)) {
    callback();
  } else {
    return callback(new Error("请输入中文或英文，长度1-10位"));
  }
};
//名称只能输入数字中文英文
export const checkNameNew = (rule, value, callback) => {
  let reg = /^[A-z0-9\u4e00-\u9fa5]*$/;
  if (reg.test(value)) {
    callback();
  } else {
    return callback(new Error("请输入中文英文数字，长度1-15位"));
  }
};
//名称只能输中文
export const checkNameCN = (rule, value, callback) => {
  let reg = /^[\u4E00-\u9FA5]{1,15}$/;
  if (reg.test(value)) {
    callback();
  } else {
    return callback(new Error("请输入中文，长度1-15位"));
  }
};
// 校验邮箱
export const checkEmail = (rule, value, callback) => {
  let reg = /^[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?$/;
  if (reg.test(value)) {
    callback();
  } else {
    return callback(new Error("邮箱格式格式不正确，请重新输入"));
  }
};

// 校验用户密码
export const checkPassword = (rule, value, callback) => {
  let reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,10}$/;
  if (reg.test(value)) {
    callback();
  } else {
    return callback(
      new Error("密码至少包含字母数字特殊字符组合中的两种，长度6-10位")
    );
  }
};
// 校验网址
export const checkURL = (rule, value, callback) => {
  let reg = /^((https|http|ftp):\/\/)[^\s]+$/;
  if (reg.test(value)) {
    callback();
  } else {
    return callback(new Error("请输入正确的网址，以https://或http://为前缀"));
  }
};
// 校验手机号
export const checkPhone = (rule, value, callback) => {
  let reg = /^1\d{10}$/;
  if (reg.test(value)) {
    callback();
  } else {
    return callback(new Error("请输入11位的手机号码"));
  }
};
// 新的手机校验
export const checkPhone2 = (rule, value, callback) => {
  let reg = /^(13[0-9]|14[5|7]|15[0|1|2|3|4|5|6|7|8|9]|17[0|1|2|3|4|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/;
  // let reg = /((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/;
  if (reg.test(value)) {
    callback();
  } else {
    return callback(new Error("请输入正确的手机号码"));
  }
};
// 校验数字 正整数
export const checkNumber = (rule, value, callback) => {
  let reg = /^[1-9]+\d*$/;
  if (reg.test(value)) {
    callback();
  } else {
    return callback(new Error("请输入大于0的整数字"));
  }
};
//校验价格 数字且只有一个小数点保留两位小数
export const checkPrice = (rule, value, callback) => {
  // let reg = /^\d*\.{0,1}\d{0,2}$/;
  // let reg = /^\d+(\.\d{0,2})?$/; //保留两位小数 包括0
  let reg = /^\d{1,9}$|^\d{1,9}[.]\d{1,2}$/; //小数点前最多9位小数点后最多只有两位而且不为负数
  if (reg.test(value)) {
    callback();
  } else {
    return callback(new Error("请输入数字，保留两位小数"));
  }
};
//校验支付宝商户号和微信商户号
export const checkChat = (rule, value, callback) => {
  let reg = /^[A-Za-z0-9]+$/;
  if (reg.test(value)) {
    callback();
  } else {
    return callback(new Error("请输入英文或者数字"));
  }
};
//校验普通密码 可输入英文数字和特殊字符
export const checkPassword10 = (rule, value, callback) => {
  let reg = /^[A-Za-z0-9-*/+.~!@#$%^&*()]{6,24}$/;
  if (reg.test(value)) {
    callback();
  } else {
    return callback(new Error("请输入英文或者数字,长度6-10位"));
  }
};
